import { parseSweep } from "../utils/sweep";

export default function sweepButtons(ctx, selector) {
    const elements = document.querySelectorAll(selector);
    for (const element of elements) {
        sweepButton(ctx, element, selector);
    }
}

function sweepButton(ctx, element, selector) {
    const [sweepId, rotX, rotY] = parseSweep(element.dataset.sweep);

    ctx.sweepManager.addSweep(sweepId);

    element.addEventListener("click", (ev) => {
        removeActiveClass(selector);

        ev.preventDefault();
        ctx.sdk.Sweep.moveTo(sweepId, {
            transition: "transition.fly",
            transitionTime: 1000,
            rotation: { x: rotX, y: rotY },
        });
        element.classList.add('font-bold');
    });
}

function removeActiveClass(selector) {
    const elements = document.querySelectorAll(selector);
    for (const element of elements) {
        element.classList.remove('font-bold');
    }
}